import { defineStore } from "pinia";
import { ref } from "vue";
import { MenuService } from "../Services/Auth/menu.service";
import { useAuthStore } from "./auth";

const STORAGE_MENU_NAME = "tdd_menu";
const STORAGE_MENU_GROUP_NAME = "tdd_menu_group";

const authStore = useAuthStore();

export const useMenuStore = defineStore("menu", () => {
    const topmenuActive = ref(0);

    const arrMenu = ref([]);
    const arrMenuGroup = ref([]);

    function reset() {
        count.value = 0;
    }

    function setMenu(menuId) {
        topmenuActive.value = menuId;
    }

    const getArrMenu = async () => {
        if (!authStore.isLoggedIn) {
            return false;
        }

        arrMenu.value = JSON.parse(localStorage.getItem(STORAGE_MENU_NAME));
        arrMenuGroup.value = JSON.parse(localStorage.getItem(STORAGE_MENU_GROUP_NAME));

        if (arrMenu.value && arrMenuGroup.value) {
            return {
                arrMenu: arrMenu.value,
                arrMenuGroup: arrMenuGroup.value
            }
        }

        const [response, error] = await (new MenuService).get();

        if (!error) {
            arrMenu.value = response.data.data.additional.arrMenus;
            arrMenuGroup.value = response.data.data.additional.menuGroup;

            localStorage.setItem(STORAGE_MENU_NAME, JSON.stringify(arrMenu.value));
            localStorage.setItem(STORAGE_MENU_GROUP_NAME, JSON.stringify(arrMenuGroup.value));

            return {
                arrMenu: arrMenu.value,
                arrMenuGroup: arrMenuGroup.value
            }
        }

        return false;
    }

    const clear = () => {
        arrMenu.value = [];
        arrMenuGroup.value = [];
        topmenuActive.value = 0;

        localStorage.removeItem(STORAGE_MENU_NAME)
        localStorage.removeItem(STORAGE_MENU_GROUP_NAME)
    }

    getArrMenu();

    return { topmenuActive, arrMenu, arrMenuGroup, reset, setMenu, getArrMenu, clear };
});
